import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerWithIconContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';
import { ConsentDeniedTooltip } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/ConsentDeniedTooltip';

type Props = {
  employeeName: string;
  consentDenyReason: string;
};
const ManagerViewEmployeeDeniedBanner = ({ employeeName, consentDenyReason }: Props) => (
  <BannerWithIconContainer
    themeColor={ThemeColorType.warning}
    justifyContent="space-between"
    alignItems="center">
    <div>
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext('%(employeeName)s denied the timesheet edits.', { employeeName })}
      </Text14>

      <div>
        <Text14 themeColor={ThemeColorType.white} semiBold>
          {gettext('Pending your approval.')}
        </Text14>
      </div>
    </div>

    <ConsentDeniedTooltip consentDenyReason={consentDenyReason} />
  </BannerWithIconContainer>
);

export default ManagerViewEmployeeDeniedBanner;
